import * as Stores from '../stores'

export function useCardApplicationStatusWithRefresh() {
  return Stores.CardApplicationApi.endpoints['GET /card/onboarding/applications'].useQuery(
    {},
    {
      pollingInterval: 5000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      selectFromResult({ data, isLoading, isUninitialized }) {
        if (isUninitialized || isLoading) return { status: 'STATUS_PENDING' as const }

        const [application] = data?.applications ?? []

        if (!application) return { status: 'NOT_FOUND' as const }

        return { status: application.status }
      },
    },
  )
}
